import React, { useState, useEffect } from "react";
import { Input, Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setOptionSelected, setSelectedOption, setComments } from "../../../redux/actions/itExperienceAction";
import { setITExperienceFeedback } from "../../../redux/actions/feedbackActions";
import { useMediaQuery } from "react-responsive";
const itExperienceTranslations = {
  English: {
    title: "IT Experience Center",
    questionLike: "What did you like at the IT Experience Center?",
    questionDislike: "What did you not like at the IT Experience Center?",
    prompt: "Please tell us more about your experience:",
    placeholder: "Comments",
  },
  Dutch: {
    title: "IT Experience Center",
    questionLike: "Wat vond je leuk aan het IT Experience Center?",
    questionDislike: "Wat vond je niet leuk aan het IT Experience Center?",
    prompt: "Vertel ons meer over uw ervaring:",
    placeholder: "Opmerkingen",
  },
  Spanish: {
    title: "IT Experience Center",
    questionLike: "¿Qué le gustó del IT Experience Center?",
    questionDislike: "¿Qué no le gustó del IT Experience Center?",
    prompt: "Por favor, cuéntenos más sobre su experiencia:",
    placeholder: "Comentarios",
  },
  Chinese: {
    title: "IT 体验中心",
    questionLike: "您喜欢 IT 体验中心哪些方面？",
    questionDislike: "您不喜欢 IT 体验中心哪些方面？",
    prompt: "请告诉我们更多关于您的经历：",
    placeholder: "评论",
  },
  Japanese: {
    title: "IT Experience Center",
    questionLike: "IT エクスペリエンスセンターで何が気に入りましたか？",
    questionDislike: "IT エクスペリエンスセンターで何が気に入りませんでしたか？",
    prompt: "体験についてもっと教えてください：",
    placeholder: "コメント",
  },
  French: {
    title: "IT Experience Center",
    questionLike: "Qu'avez-vous apprécié au IT Experience Center ?",
    questionDislike: "Qu'avez-vous pas apprécié au IT Experience Center ?",
    prompt: "Veuillez nous en dire plus sur votre expérience :",
    placeholder: "Commentaires",
  },
  German: {
    title: "IT Experience Center",
    questionLike: "Was hat Ihnen am IT Experience Center gefallen?",
    questionDislike: "Was hat Ihnen am IT Experience Center nicht gefallen?",
    prompt: "Bitte erzählen Sie uns mehr über Ihre Erfahrung:",
    placeholder: "Kommentare",
  },
};

const ITexperience = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage) || "English";
  const { selectedOption, comments } = useSelector((state) => state.ITExperience);
  const selectedITExperienceLocation = useSelector((state) => state.experience.selectedLocation);
  const feedback = useSelector((state) => state.experience.feedback);
  const [rating, setRating] = useState(0);
  useEffect(() => {
    if (feedback && feedback["IT Experience Center"] && feedback["IT Experience Center"].rating !== undefined) {
      setRating(feedback["IT Experience Center"].rating);  
    }
  }, [feedback]);

  const translations = itExperienceTranslations[selectedLanguage] || itExperienceTranslations.English;
  const englishLikeQuestion = itExperienceTranslations['English'].questionLike; 
  const englishDislikeQuestion = itExperienceTranslations['English'].questionDislike;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const question =
    rating >= 1 && rating <= 3
      ? translations.questionDislike  
      : translations.questionLike;    

  const onOptionChange = (e) => {
    const value = e.target.value;
    dispatch(setSelectedOption(value));
    dispatch(setOptionSelected(true));
    dispatch(setComments(""));
    dispatch(setITExperienceFeedback(value, rating >= 1 && rating <= 3 ? englishDislikeQuestion : englishLikeQuestion, comments, selectedITExperienceLocation));
  };
  
  const onCommentsChange = (e) => {
    const value = e.target.value;
    dispatch(setComments(value));
    dispatch(setITExperienceFeedback(selectedOption, rating >= 1 && rating <= 3 ? englishDislikeQuestion : englishLikeQuestion, value, selectedITExperienceLocation));
  };

  return (
    <section style={isMobile ? {marginRight:'4%', marginLeft:'2%' }:{marginRight:'0%' }}>
      <h2>{translations.title}</h2>

      {/* Conditionally display the question based on the rating and language */}
      <h2 style={isMobile?{paddingTop:'5%',marginRight:'5%',fontSize:'18px'  }:{paddingTop: "50px"}}>{question}</h2>

      <div>
        <Radio.Group onChange={onOptionChange} value={selectedOption}>
          <Radio value="Technician">Technician</Radio>
          <Radio value="Service">Service</Radio>
          <Radio value="Ambience">Ambience</Radio>
          <Radio value="Other">Other</Radio>
        </Radio.Group>
      </div>

      {selectedOption && (
        <>
          <p style={{ paddingTop: "30px" }}>{translations.prompt}</p>
          <Input.TextArea
            placeholder={translations.placeholder}
            // style={{ height: "60px", resize: "none" }}
            style={isMobile ? {maxWidth:'95%',height: "60px", resize: "none" }:{maxWidth:'100%',height: "60px", resize: "none" }}

            value={comments}
            onChange={onCommentsChange}
          />
        </>
      )}
    </section>
  );
};

export default ITexperience;
